/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_d998d9d0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.row_d998d9d0{height:80px}.tile_d998d9d0{position:absolute;top:0;left:0;bottom:0;right:0}\n"}]);
export const root = "root_d998d9d0";
export const row = "row_d998d9d0";
export const tile = "tile_d998d9d0";